import React from 'react';
import { useTranslation } from 'react-i18next';
import Typography from './common/Typography';

const DetailTitleSection = ({ title, description = '' }) => {
  const { t } = useTranslation('common');

  return (
    <div className="displayFlexColumn" style={{ gap: '8px' }}>
      <Typography variant="body2Bold" color="Primary-500">
        {title}
      </Typography>
      <Typography variant="subtitleBold" color="Primary">
        {description || t('detail.description')}
      </Typography>
    </div>
  );
};

export default DetailTitleSection;
